import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import { animateScroll } from 'react-scroll'

const useStyles = makeStyles({
  main: {
    height: '415px',
    overflow: 'auto',
    borderRadius: '3px',
    padding: 0,
    '&::-webkit-scrollbar': {
      width: 5,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D1',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#D1D1D1',
    },
  },
  mainMobile: {
    height: '250px',
    overflow: 'auto',
    borderRadius: '3px',
    padding: 0,
    '&::-webkit-scrollbar': {
      width: 5,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D1',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#D1D1D1',
    },
  },
  itemDetail: {
    borderBottom: '1px solid #DFE4EB',
    width: '100%',
    padding: '12px 0px',
    margin: 0,
  },
  item: {
    alignItems: 'flex-start',
    lineHeight: '22px',
    padding: 0,
  },
  date: {
    display: 'flex',
    fontSize: 10,
    color: '#8C8C8C',
    cursor: 'pointer',
    '& div:first-child': {
      width: 80,
      marginRight: 12,
      whiteSpace: 'nowrap',
    },
    '&:hover': {
      '& div:first-child': {
        color: '#474747',
      },
      '& div:nth-child(2)': {
        color: '#2160BA',
      },
    },
  },
  title: {
    color: '#1B3963',
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'left',
    width: '100%',
    paddingRight: 10,
    lineHeight: '18px',
    position: 'relative',
    top: 3,
  },
  content: {
    paddingTop: 10,
    fontSize: 12,
    color: '#181818',
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
  },
  circle: {
    width: 10,
    height: 10,
    borderRadius: '50%',
  },
})

interface NewsFeedProps {
  events: any[]
}

const NewsFeed = ({ events }: NewsFeedProps) => {
  const classes = useStyles()
  function rawMarkup(content: any) {
    return { __html: content }
  }
  const [eventDatas, setEventDatas] = useState<any[]>([])

  useEffect(() => {
    const eventsSortByDates = events
      .filter(s => s.signal_type !== 'Risk Radar SS')
      .sort((a, b) => {
        return a.date - b.date
      })
    setEventDatas(eventsSortByDates)
    animateScroll.scrollToBottom({
      containerId: 'container',
      duration: 0,
    })
  }, [events])

  const moveToLink = (url: string) => {
    if (url) {
      window.open(url, '_blank')
    }
  }

  return (
    <List
      className={isMobile ? classes.mainMobile : classes.main}
      id="container"
    >
      {events &&
        eventDatas.map((event, index) => (
          <div key={`${event.Date}-${event.title}-${index}`}>
            <ListItem className={classes.item}>
              <div className={classes.itemDetail}>
                <div
                  className={classes.date}
                  onClick={() => moveToLink(event.url)}
                >
                  <div>{moment(event.Date).format('MMM, YYYY')}</div>
                  <div
                    className={classes.title}
                    style={{ color: event?.text_color }}
                  >
                    {event.title}
                  </div>
                </div>
              </div>
            </ListItem>
          </div>
        ))}
    </List>
  )
}

export default NewsFeed
